import React from "react";
import DropDown from "../../../Form/DropDown";
import {Grid} from "@mui/material";
import {useMediaContext} from "../../../../MediaContext";

const CustomFilters = ({ category, formMethods, remotePost, isUploading }) => {
    const mediaContext = useMediaContext();

    if (!category?.customFilters || category.customFilters.length === 0) {
        return null;
    }

    return <>
        {category.customFilters.map((filter) => {
            const defaultValue = remotePost
                ? (remotePost.CustomFilters?.find(cf => cf.Key === filter.key)?.Value || "")
                : "";

            switch (filter.type) {
                case "dropdown":
                    return (
                        <Grid key={filter.key} item xs={mediaContext.isMobileSize ? 2 * filter.uiSize : filter.uiSize}>
                            <DropDown
                                key={filter.key}
                                id={`customFilter_${filter.key}`}
                                label={filter.label}
                                defaultValue={defaultValue}
                                items={filter.options.reduce((acc, option) => {
                                    acc[option.label] = option.value;
                                    return acc;
                                }, {})}
                                disabled={isUploading}
                                options={{
                                    required: filter.isRequired ? "Påkrævet" : false,
                                }}
                                formMethods={formMethods}
                            />
                        </Grid>
                    );

                // Add more filter types as needed

                default:
                    return null;
            }
        })}
    </>
};

export default CustomFilters;